import { apiRoutes } from 'routes';
import FetchHelpers from 'utils/FetchHelpers';

export default {
  index(documentId) {
    const path = apiRoutes.documentFieldsPath(documentId);
    return FetchHelpers.get(path);
  },
};
